export default __webpack_public_path__ + "static/media/InstrumentSans-Regular.3f9e6a10.woff2";